/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Settings_TitleInputs */

const en_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const fr_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const de_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const it_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const ru_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const es_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const zh_cn2_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const ja_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const hi_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स`)
};

const pt_pt2_toolbar_secondary_settings_title = /** @type {(inputs: Toolbar_Secondary_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Toolbar_Secondary_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_settings_title = /** @type {((inputs?: Toolbar_Secondary_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_settings_title(inputs)
	if (locale === "de") return de_toolbar_secondary_settings_title(inputs)
	if (locale === "it") return it_toolbar_secondary_settings_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_settings_title(inputs)
	if (locale === "es") return es_toolbar_secondary_settings_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_settings_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_settings_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_settings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_settings_title(inputs)
	return en_toolbar_secondary_settings_title(inputs)
});